




































































import {
    Component, mapState, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import TopDetail from './TopDetail.vue';
import { BarWithLineConfig, BarWithLineSetting } from '@/components/graphs/bar/bar-with-line';
import { BasicLineConfig, BasicLineSetting } from '@/components/graphs/line/basic-line';
import {
    Payload, MyaaffiliateStore, AuthorizationStore, CommonsStore,
} from '@samclick-store-factory';
import { toMoney } from '@/utils/common-utils';
import {
    getDateTodayIsoFormat, getPastDay, getStartOfCurrentMonth, getEndOfCurrentMonth, formatDate,
} from '@/utils/date-utils';
import CountryStore from "@/state/modules/country";

enum DatesOption {
    MONTH = 'THIS_MONTH',

    LAST_SEVEN = 'LAST_SEVEN',

    LAST_MONTH = 'LAST_MONTH',
}

class DashboardState {
    loadedDate: string = DatesOption.LAST_SEVEN;
    casino: string[] = [];
    isLoading: boolean = false;
    country: string[] = [];
}

type NGRDataItem = {
    date: string;
    current_ngr: number;
    previous_ngr: number;
};

interface KpiItem {
    title: string;
    icon: string;
    value: number;
    previous: number;
    isMoney: boolean;
}


@Component({
    /**
     * Imported components
     * */
    components: {
        TopDetail,
    },
    /**
     * Stores values
     * */
    computed: {
        ...mapState({
            loading: (state: any) => state.myaaffiliate.myaaffiliateStore.loading,
            mereports: (state: any) => state.myaaffiliate.myaaffiliateStore.dashboardreports,
            playerCountry:  (state: any) => state.commons.commonsStore.playerCountry,
        }),

        selectedDateOption() {
            return this.datesOption.find(
                item => item.value === this.state.loadedDate
            ) || null;
        },

        previousDate() {
            if (!this.selectedDateOption || !this.selectedDateOption.previous) {
                return null;
            }
            const prevValue = this.selectedDateOption.previous;
            return {
                value: prevValue,
            };
        }

    },
    data() {
        return {
            reports: [],
        };
    },
    /**
     * Component properties
     * */
    props: {},
})
export default class Dashboard extends mixins(SamclickMixins) {
    /**
     * Local state
     * */
    state = new DashboardState();

    datesOption = [
        { value: DatesOption.LAST_MONTH, label: 'dashboard.opt_last_month', previous: 'dashboard.opt_last_2_months'},
        { value: DatesOption.MONTH, label: 'dashboard.opt_this_month',  previous:'dashboard.opt_last_month'},
        { value: DatesOption.LAST_SEVEN, label: 'dashboard.opt_last_seven', previous:'dashboard.opt_last_fourteen'},
    ]

    activeCasinos: { id: number, code: string }[] = []

    /**
     * Watchers
     * */
    @Watch('state.loadedDate')
    @Watch('state.casino')
    @Watch('state.country')
    onDateOrCasinoChange() {
        // Reload using current date option and selected casino
        this.load(this.state.loadedDate);
    }

    /**
     * Methods
     * */
    get kpiItems(): KpiItem[] {
        var totals = this.mereports && this.mereports.totals ? this.mereports.totals : { current: {}, previous: {} };

        var current = totals.current || {};
        var previous = totals.previous || {};

        return [
            {
                title: this.$t('label.hits') as string,
                icon: 'fa fa-hand-o-up',
                value: current.total_clicks || 0,
                previous: previous.total_clicks || 0,
                isMoney: false
            },
            {
                title: this.$t('label.signups') as string,
                icon: 'fa fa-user-plus',
                value: current.total_signups || 0,
                previous: previous.total_signups || 0,
                isMoney: false
            },
            {
                title: this.$t('label.ftds') as string,
                icon: 'fa fa-money',
                value: current.total_ftd || 0,
                previous: previous.total_ftd || 0,
                isMoney: false
            },
            {
                title: this.$t('label.ngr') as string,
                icon: 'fa fa-eur',
                value: current.total_ngr || 0,
                previous: previous.total_ngr || 0,
                isMoney: true
            }
        ];
    }

    get mergedNGRData(): NGRDataItem[] {
        if (!this.mereports || !Array.isArray(this.mereports.response_data)) return [];
        const currentItems = this.mereports.response_data.filter((item: any) => item.period === 'current');

        const previousItems = this.mereports.response_data
            .filter((item: any) => item.period === 'previous')
            .reduce((acc: Record<number, number>, item: any, idx: any) => {
                acc[idx] = {
                    ngr: item.ngr || 0,
                    ftd: item.ftd || 0,
                    signups: item.signups || 0,
                    ftd_conversion: item.ftd_conversion || 0,

                };
                return acc;
            }, {});

        const merged = currentItems.map((item: any, idx: number) => {
            const prev = previousItems[idx] ? previousItems[idx] : { ngr: 0, ftd: 0 };
            return {
                date: item.date.substr(0, 10),
                current_ngr: item.ngr || 0,
                current_ftd: item.ftd || 0,
                current_signups: item.signups || 0,
                current_ftd_conversion: item.ftd_conversion || 0,

                previous_ngr: prev.ngr || 0,
                previous_ftd: prev.ftd || 0,
                previous_signups: prev.signups || 0,
                previous_ftd_conversion: prev.ftd_conversion || 0,
            }
        });
        return merged;
    }

    generateLineGraphNGRConfig() {
        const setting = [
            new BasicLineSetting(this.$t('label.net_revenue'), 'rgb(54, 162, 235)', 'current_ngr', '', true, [], 10    ),
            new BasicLineSetting(this.$t('label.previous_ngr'), 'rgb(255, 99, 132)', 'previous_ngr', '', true, [10, 5], 10    ),
        ];
        return new BasicLineConfig('date', setting);
    }

    generateLineConfig() {
        const setting = [
            new BasicLineSetting(this.$t('label.signups'), 'rgb(255, 205, 86)', 'current_signups'),
            new BasicLineSetting(this.$t('label.ftds'), 'rgb(255, 99, 132)', 'current_ftd'),
            new BasicLineSetting(this.$t('label.ftd_conversion'), 'rgb(75, 192, 192)', 'current_ftd_conversion', '', true),
        ];
        return new BasicLineConfig('date', setting);
    }

    generateCasinoNGRConfig() {
        const data = this.mergedCasinoNGRData;
        const colors = data.map(d => d.casino_color);
        const setting = [
            new BarWithLineSetting('bar', this.$t('label.net_revenue'), colors, 'current_ngr', 'left', true),
        ];
        return new BarWithLineConfig('casino_name', setting, "", true);
    }


    get mergedCasinoNGRData(): { previous_ngr: number; casino_name: string, casino_color: string; current_ngr: number}[] {
        const casinoTotals = this.mereports.casino_totals;
        if (!casinoTotals || typeof casinoTotals !== 'object') return []

        const currentItems: Array<{ casinoId: string; casino_name: string; casino_color: string, ngr: number }> = [];
        const previousItems: Record<string, { ngr: number }> = {};

        for (const key in casinoTotals) {
            if (!Object.prototype.hasOwnProperty.call(casinoTotals, key)) continue;

            const value = (casinoTotals as Record<string, any>)[key];
            if (!value) continue;

            const [period, casinoId] = key.split('|');

            if (period === 'current') {
                currentItems.push({
                    casinoId,
                    casino_name: String(value.casino_name),
                    casino_color: String(value.casino_color),
                    ngr: Number(value.total_ngr || 0),
                });
            } else if (period === 'previous') {
                previousItems[casinoId] = {
                    ngr: Number(value.total_ngr || 0),
                };
            }
        }
        const merged = currentItems.map(item => {
            const hexToRgb = (hex: string): string => {
                if (!hex) return 'rgb(229,231,235)';

                const cleanHex = hex.replace('#', '');

                if (cleanHex.length !== 6) return 'rgb(229,231,235)';

                const r = parseInt(cleanHex.substring(0, 2), 16);
                const g = parseInt(cleanHex.substring(2, 4), 16);
                const b = parseInt(cleanHex.substring(4, 6), 16);
                return `rgb(${r},${g},${b})`;
            };

            const prev = previousItems[item.casinoId] || { ngr: 0 };
            return {
                casino_name: item.casino_name.trim(),
                current_ngr: item.ngr || 0,
                casino_color: hexToRgb(item.casino_color.trim()),
                previous_ngr: prev.ngr || 0,

            };
        });

        if (merged.length === 0) {
            return [{previous_ngr: 0, casino_name: "No Data", casino_color: "rgb(229,231,235)", current_ngr: 0}];
        }
        return merged
    }

    load(param: string) {
        this.state.isLoading = true;
        const today = getDateTodayIsoFormat();
        let startDate = '';
        let endDate = '';

        if (param === DatesOption.LAST_SEVEN) {
            startDate = getPastDay(7);
            endDate = today;
        } else if (param === DatesOption.MONTH) {
            startDate = getStartOfCurrentMonth();
            endDate = getEndOfCurrentMonth();
        } else if (param === DatesOption.LAST_MONTH) {
            startDate = getStartOfCurrentMonth();
            endDate = getEndOfCurrentMonth();
        }

        startDate = `${formatDate(startDate)}T00:00:00.000Z`;
        endDate = `${formatDate(endDate)}T23:59:59.000Z`;

        let casino = this.state.casino.map(v => String(v))
        let country = this.state.country.map(c => String(c))
        MyaaffiliateStore.affiliateDashboardReport(new Payload({
            start_date: startDate,
            end_date: endDate,
            casino_id: casino,
            country_code: country,
            affiliate_id: this.getAffiliateID,
            date_option: param
        }, true)).then(() => {
        }).finally(() => {
            this.state.isLoading = false;
        });
    }

    /**
     * Computed
     * */
    get computedVal() {
        return {};
    }

    get getAffiliateID() {
            let affiliate_id = AuthorizationStore.currentLoggedUserInState.id;
            if (affiliate_id === undefined || affiliate_id === null) {
            const local_json_string = localStorage.getItem('ma-auth.currentUser') as string;
            affiliate_id = JSON.parse(local_json_string).id;
        }

        return affiliate_id;
    }

    get enabledCasinos() {
        return CommonsStore.enabledCasinos;
    }

    get getCountry() {
        if (Array.isArray(this.playerCountry)) {
            return this.playerCountry.map(function(c) {
                return CountryStore.country(c.country) ? CountryStore.country(c.country) : '';
            });
        }

    }
    /**
     * Lifecycle hooks
     * */
    created() {
        CommonsStore.fetchPlayerCountry();
        CommonsStore.fetchEnabledCasino();
    }

    mounted() {
        this.load(DatesOption.LAST_SEVEN);
    }

    beforeCreate() {
        this.commonUtil = { toMoney };
    }
}
